import YulqoMark from "./YulqoMark";
import styles from "./LoadingScreen.module.css";

interface LoadingScreenProps {
  message?: string;
}

const LoadingScreen: React.FC<LoadingScreenProps> = ({ message }) => {
  return (
    <div className={styles.container}>
      <div className={styles.content}>
        <YulqoMark size={40} spinning />
        {message && <p className={styles.message}>{message}</p>}
      </div>
    </div>
  );
};

export default LoadingScreen;
